import React from "react";
import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import styled from "styled-components";

const Mains = () => {
  return (
    <MainWarpper>
      <Home />
      <About />
      <Contact />
    </MainWarpper>
  );
};

export default Mains;

const MainWarpper = styled.div``;
